import(/* webpackMode: "eager" */ "/codebuild/output/src2836421981/src/apps/wrap.gifts/node_modules/next/dist/client/link.js");
